import { BaseSchema } from '../helpers/BaseSchema'

/**
 * Given results and a list of ids, sort the results in the order of the id array.
 * Unlisted ids go to the end
 * @param results 
 * @param ids 
 */
export const sortByIdList = <T extends BaseSchema[]>(results: T, ids: string[]) => {
  // const render = (doc: any) => `${doc.label}[${doc.id}]`
  const ret = results.sort((a, b) => {
    const aPos = ids.indexOf(a.id)
    const bPos = ids.indexOf(b.id)
    const aOff = aPos > -1 ? aPos : results.length + 1
    const bOff = bPos > -1 ? bPos : results.length + 1
    // console.log(`${render(a)} - ${render(b)} -> ${aOff} - ${bOff}`)
    return aOff - bOff
  })

  // console.log('sorted', results.map(render), ret.map(render), ids)

  return ret
}
